import { render, staticRenderFns } from "./BusinessWords.vue?vue&type=template&id=7ac48ae4&scoped=true"
import script from "./BusinessWords.vue?vue&type=script&lang=js"
export * from "./BusinessWords.vue?vue&type=script&lang=js"
import style0 from "./BusinessWords.vue?vue&type=style&index=0&id=7ac48ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac48ae4",
  null
  
)

export default component.exports